<div class="row">
  <div *ngIf="itemsSource.length > 0" class="col-sm-12">
    <input #autoInput
    fullWidth="true"
    (input)="inputChange()"
    [ngModel]="displayValue"
    nbInput
    type="text"
    [nbAutocomplete]="auto" />

    <nb-autocomplete  #auto (selectedChange)="selectionChange($event)" [handleDisplayFn]="renderValue" >

    <nb-option *ngFor="let item of filteredItems" [value]="item">
      {{this.getValue(item)}}
    </nb-option>

    </nb-autocomplete>

  </div>

  <div *ngIf="itemsSource == undefined || itemsSource == null || itemsSource.length == 0" class="col-sm-12">
      <p class="noitems">{{noItemsMessage}}</p>
    </div>
</div>

